import type { AppProps, AppContext } from "next/app";
import "@/styles/globals.css";
import { StoreProvider } from "easy-peasy";
import store from "@/store";
import AppLogic from "./appLogic";
import dynamic from "next/dynamic";
import { statTrack } from "@/utils/mtstat";

// @ts-ignore
const WpsPayModal = dynamic(() => import("@meitu/xdesign-widgets/dist/wps").then((mod) => mod.WpsPayModal), { 
  ssr: false,
});

import("@meitu/xdesign-widgets/dist/teamExports").then(
  ({ initResignedListener }) => {
    initResignedListener();
  }
);

const MyApp = ({
  Component,
  pageProps,
}: AppProps & { isPersonal: boolean }) => {
  return (
    <StoreProvider store={store}>
      <AppLogic />
      <WpsPayModal onStatTrack={statTrack} />
      <Component {...pageProps} />
    </StoreProvider>
  );
};

export default MyApp;
